import { PublicPageStyle } from "../../constants/styles";
import MainTemplate from "../templates/MainTemplate";

const MainPage = () => {
  return (
    <PublicPageStyle>
      <MainTemplate />
    </PublicPageStyle>
  );
};

export default MainPage;
